import { render, staticRenderFns } from "./DefiRepaySFTMConfirmation.vue?vue&type=template&id=371bee74&"
import script from "./DefiRepaySFTMConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiRepaySFTMConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports